module.exports = __webpack_public_path__ + "img/mic-mute-fill.84a12305.svg";